/** T-06: pessoas, perfis, versões, grupos, autenticação e acesso de suporte; nomes de perfis e permissões. */
const en = {
  'users.title': 'Users and profiles',
  'users.sub': 'Who uses the console, with which profile, and how they sign in. Profiles combine permissions by area with a data scope.',
  'users.tab.people': 'People',
  'users.tab.profiles': 'Profiles',
  'users.tab.groups': 'Directory groups',
  'users.tab.auth': 'Authentication',
  'users.invite': 'Invite people',
  'users.inviteHint': 'Or map a directory group to a profile (Directory groups tab).',
  'users.search': 'Search by name or email',
  'users.searchPlaceholder': 'E.g. sampaio',
  'users.statusFilter': 'Status',
  'users.status.active': 'Active',
  'users.status.invited': 'Invited',
  'users.status.disabled': 'Disabled',
  'users.status.pending': 'Waiting for access',
  'users.grant': 'Grant access',
  'users.reject': 'Reject',
  'users.grant.title': 'Grant access to {name}',
  'users.grant.text': 'This person signed in through the identity provider without an invitation. Choose the profiles; the first one becomes the active one.',
  'users.grant.ok': 'Grant access',
  'users.grant.done': 'Access granted to {email}.',
  'users.reject.title': 'Reject {email}?',
  'users.reject.text': 'Without blocking, the registration is deleted and a new sign-in asks for access again. Blocking keeps it disabled and further sign-ins are refused.',
  'users.reject.block': 'Block further sign-ins',
  'users.reject.ok': 'Reject',
  'users.reject.done': 'Access request of {email} rejected.',
  'users.pendingNote': 'People waiting for access signed in through the identity provider without an invitation. Grant them a profile or reject them.',
  'auth.self.title': 'People who sign in without an invitation',
  'auth.self.sub': 'Someone who signs in through the identity provider (OIDC, SAML or Active Directory) with an unknown e-mail and no mapped directory group. Applies to every method.',
  'auth.self.refuse': 'Refuse the sign-in (default)',
  'auth.self.refuseDesc': 'The person reads that they have no access yet. Nothing is recorded.',
  'auth.self.register': 'Register them as waiting for access',
  'auth.self.registerDesc': 'The person is created without any profile and cannot use Hive. Administrators of people are told by e-mail and grant or reject access in People.',
  'auth.self.hint': 'A mapped directory group still wins: its members get in directly with its profiles. The change is audited and versioned.',
  'auth.self.saved': 'Setting saved.',
  'users.empty': 'Nobody matches this search.',
  'users.col.person': 'Person',
  'users.col.profiles': 'Profiles',
  'users.col.status': 'Status',
  'users.col.last': 'Last sign-in',
  'users.notYet': 'not yet',
  'users.editOf': 'Edit {name}',
  'users.resend': 'Resend invite',
  'users.resent': 'Invite sent again to {email}.',
  'users.privileged': 'Privileged: always asks for MFA.',
  'users.invite.done.one': '{count} person invited.',
  'users.invite.done.other': '{count} people invited.',
  'users.invite.emailSent': 'Each person receives an email to set a password.',
  'users.invite.noEmail': 'No email was sent (sign-in by the company account): share the address below.',
  'users.invite.already': 'Already had access (skipped):',
  'users.invite.address': 'Sign-in address of your company',
  'users.invite.addressHint': 'If the email does not arrive, copy this address and send it another way.',
  'users.editTitle': 'Access of {name}',
  'users.profilesHint': 'The first profile becomes the active one. Changes apply on the person’s next action, without signing in again.',
  'users.statusHint': 'A disabled person cannot sign in; history and audit stay.',
  'users.cantDisableSelf': 'You can’t disable your own access.',
  'users.disable.title': 'Disable {email}?',
  'users.disable.text': 'Sign-in stops right away, in Hive and in the local account. You can turn it back on later.',
  'users.disable.ok': 'Disable access',
  'users.saved': 'Access of {email} saved.',

  'profiles.new': 'New profile',
  'profiles.hint': 'Default profiles can be duplicated and adjusted; the original never changes.',
  'profiles.empty': 'No profiles yet.',
  'profiles.builtin': 'Default',
  'profiles.custom': 'Created by the company',
  'profiles.privileged': 'Privileged · MFA always',
  'profiles.people.one': '{count} person',
  'profiles.people.other': '{count} people',
  'profiles.duplicate': 'Duplicate and adjust',
  'profiles.permCount.one': '{count} permission',
  'profiles.permCount.other': '{count} permissions',
  'profiles.mfa.privileged': 'MFA always (privileged profile)',
  'profiles.mfa.required': 'MFA always required',
  'profiles.mfa.outside': 'MFA outside the company network',
  'profiles.mfa.idp': 'MFA as the identity provider decides',
  'profiles.mfaOpt.required': 'Always required',
  'profiles.mfaOpt.outside-network': 'Required outside the company network',
  'profiles.mfaOpt.idp': 'As the identity provider decides',
  'profiles.delete.title': 'Delete the profile {name}?',
  'profiles.delete.text': 'It can only be deleted when nobody has it. Its versions stay in the audit trail.',
  'profiles.delete.ok': 'Delete profile',
  'profiles.deleted': 'Profile {name} deleted.',
  'profiles.back': 'Back to profiles',
  'profiles.editTitle': 'Edit profile: {name}',
  'profiles.duplicateTitle': 'Duplicate and adjust profile',
  'profiles.copyOf': '{name} (copy)',
  'profiles.editorSub': 'Permissions by area, data scope and MFA policy. Saving creates a version you can compare and restore.',
  'profiles.saveChanges': 'Save changes',
  'profiles.scopeNote': "The scope limits which assets the profile sees. It applies as soon as the profile is saved.",
  'profiles.permNote': "Every permission of the product is listed, including modules not in use, so the profile is ready when they are turned on.",
  'profiles.savedVersion': 'Profile saved (version {version}). It applies on each person’s next action.',
  'profiles.undone': 'Change undone: the previous version is current again.',
  'profiles.savedTitle': 'Profile {name} saved.',
  'profiles.savedText': 'It is in the audit trail and has its first version.',
  'profiles.savedTextEdit': 'The change is in the audit trail and created a new version you can compare and restore.',
  'profiles.editAgain': 'Open the profile',

  'versions.title': 'Versions',
  'versions.none': 'No versions yet. The first one is created on the next save.',
  'versions.current': 'current',
  'versions.legendOut': 'Value that left',
  'versions.legendIn': 'Value that came in',
  'versions.compare': 'Comparison between version {a} and version {b}',
  'versions.field': 'Field',
  'versions.before': 'v{version} · before',
  'versions.after': 'v{version} · current',
  'versions.same': 'No differences between these versions.',
  'versions.changed': 'changed',
  'versions.added': 'added',
  'versions.restore': 'Restore version {version}',
  'versions.restoreTitle': 'Restore version {version}?',
  'versions.restoreText': 'The values of that version become current again. The restore also creates a new version ({next}), so you can go back.',
  'versions.restored': 'Version restored as v{version}.',
  'versions.noRestore': 'Your active profile can compare versions but not restore them.',
  'versions.scopeAll': 'Whole company',
  'versions.scope.sites': 'Sites',
  'versions.scope.tags': 'Tags',
  'versions.scope.groups': 'Groups',
  'versions.path.name': 'Profile name',
  'versions.path.description': 'Who is it for',
  'versions.path.permissions': 'Permissions',
  'versions.path.privileged': 'Privileged profile',
  'versions.path.mfa': 'MFA policy',
  'versions.path.scope': 'Data scope',

  'groups.note': 'Whoever signs in with the company account and is in a mapped group gets the profile without a manual invite (JIT). Whoever leaves the group loses it on the next sign-in.',
  'groups.col.group': 'Directory group',
  'groups.col.profile': 'Profile granted',
  'groups.empty': 'No groups mapped yet.',
  'groups.add': 'Add group',
  'groups.save': 'Save mappings',
  'groups.remove': 'Remove group {group}',
  'groups.saved.one': '{count} mapping saved.',
  'groups.saved.other': '{count} mappings saved.',

  'auth.intro': 'Only the methods turned on appear on the sign-in page. Directory connections (Entra ID, Okta…) are managed in the Integrations Center.',
  'auth.introLink': 'Open the Integrations Center',
  'auth.oidc.title': 'OIDC / OAuth 2.0',
  'auth.oidc.desc': 'Sign in with the company identity provider: Entra ID, Google, Okta, Keycloak.',
  'auth.saml.title': 'SAML 2.0',
  'auth.saml.desc': 'For identity providers that only speak SAML (ADFS and others).',
  'auth.ldap.title': 'LDAP / Active Directory',
  'auth.ldap.desc': 'Domain user and password, validated in Active Directory by the collector via LDAPS.',
  'auth.ldap.collector': 'Applied by the collector.',
  'auth.ldap.f1': "Applied by the collector: connect the Active Directory first (Integrations › Directory).",
  'auth.local.title': 'Local account + MFA',
  'auth.local.desc': 'For installations without an identity provider, emergency accounts and external auditors.',
  'auth.local.summary': 'Strong password; MFA required for privileged profiles.',
  'auth.on': 'On',
  'auth.offState': 'Off',
  'auth.notConfigured': 'Not configured yet.',
  'auth.configure': 'Configure',
  'auth.toggle': 'Turn {method} on or off',
  'auth.turnedOn': '{method} turned on. The sign-in page already shows it.',
  'auth.turnedOff': '{method} turned off.',
  'auth.off.title': 'Turn off {method}?',
  'auth.off.text': 'People who sign in this way will need another method. At least one method always stays on.',
  'auth.off.ok': 'Turn off',
  'auth.wz.redirect': 'Register this return address in the identity provider (it is the only thing to copy):',
  'auth.wz.done': '{method} saved and turned on.',
  'auth.wz.doneText': 'The secret went to the vault and is never shown again. The sign-in page already shows this option.',
  'auth.wz.test': 'Test the sign-in',
  'auth.wz.testHint': 'Open this address in a private window and choose “Sign in with your company account”. If something fails, the error appears there with the reason.',
  'auth.mfa.title': 'MFA policy by profile',
  'auth.mfa.sub': 'privileged profiles always require MFA, even when the identity provider does not ask for it',
  'auth.mfa.profile': 'Profile',
  'auth.mfa.policy': 'MFA',
  'auth.mfa.hint': 'Change the policy in the profile editor.',

  'support.title': 'Support access requests from the service provider',
  'support.sub': 'valid only with your approval, for a limited time, and every action goes to the audit trail',
  'support.empty': 'No requests.',
  'support.emptyText': 'When the service provider team asks to help, the request appears here for you to approve or deny.',
  'support.status.pending': 'Waiting for approval',
  'support.status.approved': 'Approved',
  'support.status.denied': 'Denied',
  'support.status.revoked': 'Revoked',
  'support.status.expired': 'Expired',
  'support.approveFor': 'Approve for {minutes} min',
  'support.requested': 'requested {when}',
  'support.until': 'until {when}',
  'support.decidedBy': 'decided by {who}',
  'support.approve.title': 'Approve access for {who}?',
  'support.approve.text': 'Read-only access for {minutes} minutes. Every action is recorded in your audit trail; you can revoke it at any time.',
  'support.approve.ok': 'Approve',
  'support.approve.done': 'Access approved. It ends by itself at the end of the period.',
  'support.deny.title': 'Deny the request from {who}?',
  'support.deny.text': 'The service provider team will not see your data.',
  'support.deny.ok': 'Deny',
  'support.deny.done': 'Request denied.',
  'support.revoke.title': 'Revoke the access of {who} now?',
  'support.revoke.text': 'The access ends immediately, even before the {minutes} minutes.',
  'support.revoke.ok': 'Revoke now',
  'support.revoke.done': 'Access revoked.',

  'profile.platform-admin': 'Platform administrator',
  'profile.noc-analyst': 'Infrastructure / NOC analyst',
  'profile.security-analyst': 'Security analyst',
  'profile.support-technician': 'Support technician (L1/L2)',
  'profile.license-manager': 'License manager (SAM)',
  'profile.asset-analyst': 'Asset analyst (HAM)',
  'profile.manager': 'Manager / executive',
  'profile.auditor': 'Auditor',
  'profile.end-user': 'End user',
  'profile.platform-admin.desc': 'Administers everything in the company: people, profiles, sign-in, integrations and settings.',
  'profile.noc-analyst.desc': 'Inventory, alerts, agents and reports.',
  'profile.security-analyst.desc': 'Vulnerabilities, alerts, reports and the audit trail.',
  'profile.support-technician.desc': 'Sees assets and alerts and starts remote access with consent.',
  'profile.license-manager.desc': 'Licenses, contracts and the software Store.',
  'profile.asset-analyst.desc': 'Hardware inventory and life cycle.',
  'profile.manager.desc': 'Reads summaries and reports.',
  'profile.auditor.desc': 'Reads the audit trail, configuration versions and reports.',
  'profile.end-user.desc': 'Uses the help and the software Store.',

  'area.agents': 'Agents',
  'area.alerts': 'Alerts',
  'area.api': 'API',
  'area.assets': 'Assets and inventory',
  'area.audit': 'Audit',
  'area.auth': 'Sign-in',
  'area.config': 'Configuration versions',
  'area.help': 'Help',
  'area.home': 'Home',
  'area.integrations': 'Integrations',
  'area.licenses': 'Licenses',
  'area.profiles': 'Profiles',
  'area.remote': 'Remote access',
  'area.reports': 'Reports and dashboards',
  'area.settings': 'Company settings',
  'area.store': 'Software Store',
  'area.support': 'Support access',
  'area.users': 'People',
  'area.vulnerabilities': 'Vulnerabilities',

  'perm.home:read': 'See the Home screen',
  'perm.users:read': 'See people and profiles',
  'perm.users:admin': 'Invite and manage people',
  'perm.profiles:admin': 'Create and edit profiles',
  'perm.auth:admin': 'Configure sign-in methods',
  'perm.settings:admin': 'Change company settings',
  'perm.audit:read': 'Read the audit trail',
  'perm.config:read': 'See configuration versions',
  'perm.config:write': 'Restore configuration versions',
  'perm.integrations:read': 'See integrations',
  'perm.integrations:admin': 'Connect and manage integrations',
  'perm.api:admin': 'Manage integration accounts (API)',
  'perm.support:approve': 'Approve support access',
  'perm.help:read': 'Use the help',
  'perm.assets:read': 'See assets',
  'perm.trust:read': 'Read the device trust signal (conditional access)',
  'perm.assets:write': 'Edit assets',
  'perm.alerts:read': 'See alerts',
  'perm.alerts:admin': 'Manage alert rules',
  'perm.agents:admin': 'Manage agents',
  'perm.reports:read': 'See reports and dashboards',
  'perm.reports:write': 'Build reports and dashboards',
  'perm.vulnerabilities:read': 'See vulnerabilities',
  'perm.licenses:admin': 'Manage licenses and contracts',
  'perm.remote:access': 'Start remote access',
  'perm.store:use': 'Use the software Store',
  'perm.store:admin': 'Manage the software Store',

  'scope.assets': 'Assets and details',
  'scope.software': 'Software and usage',
  'scope.relationships': 'Relationships and maps',
  'scope.network': 'Network (ports, VLANs, subnets)',
  'scope.cloud': 'Cloud, virtualization and Kubernetes',
  'scope.contracts': 'Contracts, licenses and SKUs',
  'scope.vulnerabilities': 'Vulnerabilities and insights',
  'scope.alerts': 'Alerts and events',
  'scope.tickets': 'Tickets and changes',
  'scope.reports': 'Reports',
  'scope.audit': 'Audit trail',
  'scope.identity': 'People and identity',
  'scope.trust': 'Device trust signal (conditional access)',
  'perm.vulnerabilities:approve': 'Approve risk acceptance',
  'perm.licenses:keys-view': 'See license keys',
  "pmx.search": "Search screen or action",
  "pmx.onlyMarked": "Only marked",
  "pmx.count": "{n} of {total} marked",
  "pmx.screen": "Screen",
  "pmx.view": "View",
  "pmx.edit": "Edit",
  "pmx.actions": "Specific actions",
  "pmx.blockView": "View every screen of {block}",
  "pmx.blockEdit": "Edit every screen of {block}",
  "pmx.viewOf": "View {screen}",
  "pmx.editOf": "Edit {screen}",
  "pmx.sensitive": "Sensitive action: requires a privileged profile (with MFA)",
  "pmx.sensitiveNote": "Sensitive actions should only go to privileged profiles, which always require MFA.",
  "perm.action.assets.export": "Export the list",
  "perm.action.assets.retire": "Retire assets",
  "perm.action.assets.changeKind": "Change the type",
  "perm.action.agents.install": "Create installers",
  "perm.action.agents.classApprove": "Approve class changes",
  "perm.action.discovery.run": "Run scans",
  "perm.action.maps.shareMap": "Share maps",
  "perm.action.alerts.acknowledge": "Acknowledge",
  "perm.action.alerts.close": "Resolve and close",
  "perm.action.itsm.openTicket": "Open tickets",
  "perm.action.response.isolate": "Isolate machine",
  "perm.action.response.killProcess": "Kill process",
  "perm.action.response.emergencyBrake": "Emergency brake",
  "perm.action.hunting.falsePositive": "Mark false positive",
  "perm.action.defender.scan": "Run scans",
  "perm.action.defender.exclusion": "Approve exclusions",
  "perm.action.vulns.export": "Export CSV",
  "perm.action.vulns.approveRisk": "Approve risk acceptance",
  "perm.action.diskEncryption.revealKey": "Reveal recovery key",
  "perm.action.remote.approve": "Approve unattended access",
  "perm.action.licenses.revealKey": "Reveal license keys",
  "perm.action.reports.export": "Export",
  "perm.action.reports.schedule": "Schedule sending",
  "perm.action.deployments.approve": "Approve deployments",
  "perm.action.scripts.run": "Run scripts",
  "perm.action.playbooks.run": "Run playbooks",
  "perm.action.privileges.grant": "Grant elevation",
  "perm.action.credentials.reveal": "Reveal credentials",
  "perm.action.users.profiles": "Edit profiles",
  "perm.action.users.signIn": "Sign-in settings",
  "perm.action.users.apiAccounts": "API accounts",
  "perm.action.audit.export": "Export audit",
  "perm.action.support.approve": "Approve provider support",
  "nav.uninstallCode": "Uninstall code",
  "uc.title": "Uninstall code",
  "uc.sub": "The agent only leaves a machine with an order from the console or with this single-use code. Type the challenge shown on the machine.",
  "uc.machine": "Machine",
  "uc.choose": "Choose the machine",
  "uc.challenge": "Challenge shown on the machine",
  "uc.reason": "Why (goes to the audit)",
  "uc.generate": "Generate code",
  "uc.answer": "Read this to the person at the machine",
  "uc.validUntil": "Valid until {at}, one use",
  "uc.pending": "Servers and Tier 0 need a second person to approve; the code shows here and in the agent page once approved.",
  "uc.note": "Only profiles with the action allowed see this screen. Each code works once, for a few minutes, and every request is audited.",
  "perm.action.agents.uninstallCode": "Uninstall code (mobile)",
} as const;

type K = keyof typeof en;

const ptBR: Record<K, string> = {
  'users.title': 'Usuários e perfis',
  'users.sub': 'Quem usa a console, com qual perfil e como entra. Perfis combinam permissões por área com um escopo de dados.',
  'users.tab.people': 'Pessoas',
  'users.tab.profiles': 'Perfis',
  'users.tab.groups': 'Grupos do diretório',
  'users.tab.auth': 'Autenticação',
  'users.invite': 'Convidar pessoas',
  'users.inviteHint': 'Ou vincule um grupo do diretório a um perfil (aba Grupos do diretório).',
  'users.search': 'Buscar por nome ou e-mail',
  'users.searchPlaceholder': 'Ex.: sampaio',
  'users.statusFilter': 'Situação',
  'users.status.active': 'Ativa',
  'users.status.invited': 'Convidada',
  'users.status.disabled': 'Desativada',
  'users.status.pending': 'Aguardando acesso',
  'users.grant': 'Conceder acesso',
  'users.reject': 'Recusar',
  'users.grant.title': 'Conceder acesso a {name}',
  'users.grant.text': 'Esta pessoa entrou pelo provedor de identidade sem convite. Escolha os perfis; o primeiro vira o ativo.',
  'users.grant.ok': 'Conceder acesso',
  'users.grant.done': 'Acesso concedido a {email}.',
  'users.reject.title': 'Recusar {email}?',
  'users.reject.text': 'Sem bloquear, o cadastro é apagado e uma nova entrada pede acesso de novo. Bloqueando, ele fica desativado e novas entradas são recusadas.',
  'users.reject.block': 'Bloquear novas entradas',
  'users.reject.ok': 'Recusar',
  'users.reject.done': 'Pedido de acesso de {email} recusado.',
  'users.pendingNote': 'Quem aguarda acesso entrou pelo provedor de identidade sem convite. Conceda um perfil ou recuse.',
  'auth.self.title': 'Quem entra sem convite',
  'auth.self.sub': 'Quem entra pelo provedor de identidade (OIDC, SAML ou Active Directory) com um e-mail desconhecido e sem grupo do diretório mapeado. Vale para todos os métodos.',
  'auth.self.refuse': 'Recusar a entrada (padrão)',
  'auth.self.refuseDesc': 'A pessoa lê que ainda não tem acesso. Nada é registrado.',
  'auth.self.register': 'Cadastrar aguardando acesso',
  'auth.self.registerDesc': 'A pessoa é criada sem nenhum perfil e não consegue usar o Hive. Os administradores de pessoas recebem um e-mail e concedem ou recusam o acesso em Pessoas.',
  'auth.self.hint': 'Grupo do diretório mapeado continua valendo: os membros entram direto com os perfis dele. A mudança é auditada e versionada.',
  'auth.self.saved': 'Configuração salva.',
  'users.empty': 'Ninguém corresponde a esta busca.',
  'users.col.person': 'Pessoa',
  'users.col.profiles': 'Perfis',
  'users.col.status': 'Situação',
  'users.col.last': 'Último acesso',
  'users.notYet': 'ainda não',
  'users.editOf': 'Editar {name}',
  'users.resend': 'Reenviar convite',
  'users.resent': 'Convite reenviado para {email}.',
  'users.privileged': 'Privilegiado: sempre pede MFA.',
  'users.invite.done.one': '{count} pessoa convidada.',
  'users.invite.done.other': '{count} pessoas convidadas.',
  'users.invite.emailSent': 'Cada pessoa recebe um e-mail para definir a senha.',
  'users.invite.noEmail': 'Nenhum e-mail foi enviado (entrada pela conta da empresa): compartilhe o endereço abaixo.',
  'users.invite.already': 'Já tinham acesso (ignoradas):',
  'users.invite.address': 'Endereço de entrada da sua empresa',
  'users.invite.addressHint': 'Se o e-mail não chegar, copie este endereço e envie por outro meio.',
  'users.editTitle': 'Acesso de {name}',
  'users.profilesHint': 'O primeiro perfil vira o ativo. As mudanças valem na próxima ação da pessoa, sem novo login.',
  'users.statusHint': 'Pessoa desativada não entra; o histórico e a auditoria ficam.',
  'users.cantDisableSelf': 'Você não pode desativar o próprio acesso.',
  'users.disable.title': 'Desativar {email}?',
  'users.disable.text': 'A entrada para na hora, no Hive e na conta local. Dá para religar depois.',
  'users.disable.ok': 'Desativar acesso',
  'users.saved': 'Acesso de {email} salvo.',

  'profiles.new': 'Novo perfil',
  'profiles.hint': 'Perfis padrão podem ser duplicados e ajustados; o original nunca muda.',
  'profiles.empty': 'Ainda não há perfis.',
  'profiles.builtin': 'Padrão',
  'profiles.custom': 'Criado pela empresa',
  'profiles.privileged': 'Privilegiado · MFA sempre',
  'profiles.people.one': '{count} pessoa',
  'profiles.people.other': '{count} pessoas',
  'profiles.duplicate': 'Duplicar e ajustar',
  'profiles.permCount.one': '{count} permissão',
  'profiles.permCount.other': '{count} permissões',
  'profiles.mfa.privileged': 'MFA sempre (perfil privilegiado)',
  'profiles.mfa.required': 'MFA sempre obrigatório',
  'profiles.mfa.outside': 'MFA fora da rede da empresa',
  'profiles.mfa.idp': 'MFA como o provedor de identidade decidir',
  'profiles.mfaOpt.required': 'Sempre obrigatório',
  'profiles.mfaOpt.outside-network': 'Obrigatório fora da rede da empresa',
  'profiles.mfaOpt.idp': 'Como o provedor de identidade decidir',
  'profiles.delete.title': 'Excluir o perfil {name}?',
  'profiles.delete.text': 'Só é possível excluir quando ninguém o tem. As versões continuam na trilha de auditoria.',
  'profiles.delete.ok': 'Excluir perfil',
  'profiles.deleted': 'Perfil {name} excluído.',
  'profiles.back': 'Voltar aos perfis',
  'profiles.editTitle': 'Editar perfil: {name}',
  'profiles.duplicateTitle': 'Duplicar e ajustar perfil',
  'profiles.copyOf': '{name} (cópia)',
  'profiles.editorSub': 'Permissões por área, escopo de dados e política de MFA. Salvar cria uma versão que dá para comparar e restaurar.',
  'profiles.saveChanges': 'Salvar alterações',
  'profiles.scopeNote': "O escopo limita quais ativos o perfil vê. Ele vale assim que o perfil é salvo.",
  'profiles.permNote': "Todas as permissões do produto aparecem, inclusive de módulos ainda não usados, para o perfil ficar pronto quando forem ligados.",
  'profiles.savedVersion': 'Perfil salvo (versão {version}). Vale na próxima ação de cada pessoa.',
  'profiles.undone': 'Alteração desfeita: a versão anterior voltou a valer.',
  'profiles.savedTitle': 'Perfil {name} salvo.',
  'profiles.savedText': 'Ele está na trilha de auditoria e já tem a primeira versão.',
  'profiles.savedTextEdit': 'A alteração está na trilha de auditoria e criou uma versão nova, que dá para comparar e restaurar.',
  'profiles.editAgain': 'Abrir o perfil',

  'versions.title': 'Versões',
  'versions.none': 'Ainda não há versões. A primeira nasce no próximo salvamento.',
  'versions.current': 'atual',
  'versions.legendOut': 'Valor que saiu',
  'versions.legendIn': 'Valor que entrou',
  'versions.compare': 'Comparação entre a versão {a} e a versão {b}',
  'versions.field': 'Campo',
  'versions.before': 'v{version} · antes',
  'versions.after': 'v{version} · atual',
  'versions.same': 'Não há diferenças entre estas versões.',
  'versions.changed': 'alterado',
  'versions.added': 'incluído',
  'versions.restore': 'Restaurar a versão {version}',
  'versions.restoreTitle': 'Restaurar a versão {version}?',
  'versions.restoreText': 'Os valores daquela versão voltam a valer. A restauração também cria uma versão nova ({next}), então dá para voltar atrás.',
  'versions.restored': 'Versão restaurada como v{version}.',
  'versions.noRestore': 'Seu perfil ativo pode comparar versões, mas não restaurá-las.',
  'versions.scopeAll': 'Toda a empresa',
  'versions.scope.sites': 'Localidades',
  'versions.scope.tags': 'Tags',
  'versions.scope.groups': 'Grupos',
  'versions.path.name': 'Nome do perfil',
  'versions.path.description': 'Para quem é',
  'versions.path.permissions': 'Permissões',
  'versions.path.privileged': 'Perfil privilegiado',
  'versions.path.mfa': 'Política de MFA',
  'versions.path.scope': 'Escopo de dados',

  'groups.note': 'Quem entra com a conta da empresa e está num grupo mapeado ganha o perfil sem convite manual (JIT). Quem sai do grupo perde no próximo acesso.',
  'groups.col.group': 'Grupo do diretório',
  'groups.col.profile': 'Perfil concedido',
  'groups.empty': 'Nenhum grupo mapeado ainda.',
  'groups.add': 'Incluir grupo',
  'groups.save': 'Salvar mapeamentos',
  'groups.remove': 'Remover o grupo {group}',
  'groups.saved.one': '{count} mapeamento salvo.',
  'groups.saved.other': '{count} mapeamentos salvos.',

  'auth.intro': 'Só os métodos ligados aparecem na tela de entrada. As conexões com diretórios (Entra ID, Okta…) são gerenciadas na Central de integrações.',
  'auth.introLink': 'Abrir a Central de integrações',
  'auth.oidc.title': 'OIDC / OAuth 2.0',
  'auth.oidc.desc': 'Entrar com o provedor de identidade da empresa: Entra ID, Google, Okta, Keycloak.',
  'auth.saml.title': 'SAML 2.0',
  'auth.saml.desc': 'Para provedores de identidade que só falam SAML (ADFS e outros).',
  'auth.ldap.title': 'LDAP / Active Directory',
  'auth.ldap.desc': 'Usuário e senha do domínio, validados no Active Directory pelo coletor via LDAPS.',
  'auth.ldap.collector': 'Aplicado pelo coletor.',
  'auth.ldap.f1': "Aplicado pelo coletor: conecte antes o Active Directory (Integrações › Diretório).",
  'auth.local.title': 'Conta local + MFA',
  'auth.local.desc': 'Para instalações sem provedor de identidade, contas de emergência e auditores externos.',
  'auth.local.summary': 'Senha forte; MFA obrigatório para perfis privilegiados.',
  'auth.on': 'Ligado',
  'auth.offState': 'Desligado',
  'auth.notConfigured': 'Ainda não configurado.',
  'auth.configure': 'Configurar',
  'auth.toggle': 'Ligar ou desligar {method}',
  'auth.turnedOn': '{method} ligado. A tela de entrada já mostra.',
  'auth.turnedOff': '{method} desligado.',
  'auth.off.title': 'Desligar {method}?',
  'auth.off.text': 'Quem entra por este método vai precisar de outro. Ao menos um método sempre fica ligado.',
  'auth.off.ok': 'Desligar',
  'auth.wz.redirect': 'Cadastre este endereço de retorno no provedor de identidade (é a única coisa para copiar):',
  'auth.wz.done': '{method} salvo e ligado.',
  'auth.wz.doneText': 'O segredo foi para o cofre e nunca volta a aparecer. A tela de entrada já mostra esta opção.',
  'auth.wz.test': 'Testar a entrada',
  'auth.wz.testHint': 'Abra este endereço numa janela anônima e escolha “Entrar com a conta da empresa”. Se algo falhar, o erro aparece lá com o motivo.',
  'auth.mfa.title': 'Política de MFA por perfil',
  'auth.mfa.sub': 'perfis privilegiados sempre exigem MFA, mesmo que o provedor de identidade não peça',
  'auth.mfa.profile': 'Perfil',
  'auth.mfa.policy': 'MFA',
  'auth.mfa.hint': 'Mude a política no editor do perfil.',

  'support.title': 'Pedidos de acesso de suporte do provedor de serviços',
  'support.sub': 'só valem com a sua aprovação, por tempo limitado, e cada ação vai para a trilha de auditoria',
  'support.empty': 'Nenhum pedido.',
  'support.emptyText': 'Quando a equipe do provedor pedir para ajudar, o pedido aparece aqui para você aprovar ou recusar.',
  'support.status.pending': 'Aguardando aprovação',
  'support.status.approved': 'Aprovado',
  'support.status.denied': 'Recusado',
  'support.status.revoked': 'Revogado',
  'support.status.expired': 'Vencido',
  'support.approveFor': 'Aprovar por {minutes} min',
  'support.requested': 'pedido {when}',
  'support.until': 'até {when}',
  'support.decidedBy': 'decidido por {who}',
  'support.approve.title': 'Aprovar o acesso de {who}?',
  'support.approve.text': 'Acesso só de leitura por {minutes} minutos. Cada ação fica na sua trilha de auditoria; dá para revogar a qualquer momento.',
  'support.approve.ok': 'Aprovar',
  'support.approve.done': 'Acesso aprovado. Ele termina sozinho no fim do prazo.',
  'support.deny.title': 'Recusar o pedido de {who}?',
  'support.deny.text': 'A equipe do provedor não verá os seus dados.',
  'support.deny.ok': 'Recusar',
  'support.deny.done': 'Pedido recusado.',
  'support.revoke.title': 'Revogar agora o acesso de {who}?',
  'support.revoke.text': 'O acesso termina na hora, mesmo antes dos {minutes} minutos.',
  'support.revoke.ok': 'Revogar agora',
  'support.revoke.done': 'Acesso revogado.',

  'profile.platform-admin': 'Administrador da plataforma',
  'profile.noc-analyst': 'Analista de infraestrutura / NOC',
  'profile.security-analyst': 'Analista de segurança',
  'profile.support-technician': 'Técnico de suporte (N1/N2)',
  'profile.license-manager': 'Gestor de licenças (SAM)',
  'profile.asset-analyst': 'Analista de ativos (HAM)',
  'profile.manager': 'Gestor / executivo',
  'profile.auditor': 'Auditor',
  'profile.end-user': 'Usuário final',
  'profile.platform-admin.desc': 'Administra tudo na empresa: pessoas, perfis, entrada, integrações e configurações.',
  'profile.noc-analyst.desc': 'Inventário, alertas, agentes e relatórios.',
  'profile.security-analyst.desc': 'Vulnerabilidades, alertas, relatórios e trilha de auditoria.',
  'profile.support-technician.desc': 'Vê ativos e alertas e inicia acesso remoto com consentimento.',
  'profile.license-manager.desc': 'Licenças, contratos e a Loja de software.',
  'profile.asset-analyst.desc': 'Inventário e ciclo de vida do hardware.',
  'profile.manager.desc': 'Lê resumos e relatórios.',
  'profile.auditor.desc': 'Lê a trilha de auditoria, as versões de configuração e os relatórios.',
  'profile.end-user.desc': 'Usa a ajuda e a Loja de software.',

  'area.agents': 'Agentes',
  'area.alerts': 'Alertas',
  'area.api': 'API',
  'area.assets': 'Ativos e inventário',
  'area.audit': 'Auditoria',
  'area.auth': 'Entrada',
  'area.config': 'Versões de configuração',
  'area.help': 'Ajuda',
  'area.home': 'Início',
  'area.integrations': 'Integrações',
  'area.licenses': 'Licenças',
  'area.profiles': 'Perfis',
  'area.remote': 'Acesso remoto',
  'area.reports': 'Relatórios e painéis',
  'area.settings': 'Configurações da empresa',
  'area.store': 'Loja de software',
  'area.support': 'Acesso de suporte',
  'area.users': 'Pessoas',
  'area.vulnerabilities': 'Vulnerabilidades',

  'perm.home:read': 'Ver o Início',
  'perm.users:read': 'Ver pessoas e perfis',
  'perm.users:admin': 'Convidar e administrar pessoas',
  'perm.profiles:admin': 'Criar e editar perfis',
  'perm.auth:admin': 'Configurar métodos de entrada',
  'perm.settings:admin': 'Mudar as configurações da empresa',
  'perm.audit:read': 'Ler a trilha de auditoria',
  'perm.config:read': 'Ver versões de configuração',
  'perm.config:write': 'Restaurar versões de configuração',
  'perm.integrations:read': 'Ver integrações',
  'perm.integrations:admin': 'Conectar e administrar integrações',
  'perm.api:admin': 'Administrar contas de integração (API)',
  'perm.support:approve': 'Aprovar acesso de suporte',
  'perm.help:read': 'Usar a ajuda',
  'perm.assets:read': 'Ver ativos',
  'perm.trust:read': 'Ler o sinal de confiança da máquina (acesso condicional)',
  'perm.assets:write': 'Editar ativos',
  'perm.alerts:read': 'Ver alertas',
  'perm.alerts:admin': 'Administrar regras de alerta',
  'perm.agents:admin': 'Administrar agentes',
  'perm.reports:read': 'Ver relatórios e painéis',
  'perm.reports:write': 'Montar relatórios e painéis',
  'perm.vulnerabilities:read': 'Ver vulnerabilidades',
  'perm.licenses:admin': 'Administrar licenças e contratos',
  'perm.remote:access': 'Iniciar acesso remoto',
  'perm.store:use': 'Usar a Loja de software',
  'perm.store:admin': 'Administrar a Loja de software',

  'scope.assets': 'Ativos e detalhes',
  'scope.software': 'Software e uso',
  'scope.relationships': 'Relacionamentos e mapas',
  'scope.network': 'Rede (portas, VLANs, sub-redes)',
  'scope.cloud': 'Nuvem, virtualização e Kubernetes',
  'scope.contracts': 'Contratos, licenças e SKUs',
  'scope.vulnerabilities': 'Vulnerabilidades e insights',
  'scope.alerts': 'Alertas e eventos',
  'scope.tickets': 'Chamados e mudanças',
  'scope.reports': 'Relatórios',
  'scope.audit': 'Trilha de auditoria',
  'scope.identity': 'Pessoas e identidade',
  'scope.trust': 'Sinal de confiança das máquinas (acesso condicional)',
  'perm.vulnerabilities:approve': 'Aprovar aceite de risco',
  'perm.licenses:keys-view': 'Ver chaves de licença',
  "pmx.search": "Procurar tela ou ação",
  "pmx.onlyMarked": "Só marcadas",
  "pmx.count": "{n} de {total} marcadas",
  "pmx.screen": "Tela",
  "pmx.view": "Ver",
  "pmx.edit": "Editar",
  "pmx.actions": "Ações específicas",
  "pmx.blockView": "Ver todas as telas de {block}",
  "pmx.blockEdit": "Editar todas as telas de {block}",
  "pmx.viewOf": "Ver {screen}",
  "pmx.editOf": "Editar {screen}",
  "pmx.sensitive": "Ação sensível: pede perfil privilegiado (com MFA)",
  "pmx.sensitiveNote": "Ações sensíveis devem ficar só em perfis privilegiados, que sempre exigem MFA.",
  "perm.action.assets.export": "Exportar a lista",
  "perm.action.assets.retire": "Aposentar ativos",
  "perm.action.assets.changeKind": "Trocar o tipo",
  "perm.action.agents.install": "Criar instaladores",
  "perm.action.agents.classApprove": "Aprovar troca de classe",
  "perm.action.discovery.run": "Rodar varreduras",
  "perm.action.maps.shareMap": "Compartilhar mapas",
  "perm.action.alerts.acknowledge": "Reconhecer",
  "perm.action.alerts.close": "Resolver e fechar",
  "perm.action.itsm.openTicket": "Abrir chamados",
  "perm.action.response.isolate": "Isolar máquina",
  "perm.action.response.killProcess": "Encerrar processo",
  "perm.action.response.emergencyBrake": "Freio de emergência",
  "perm.action.hunting.falsePositive": "Marcar falso positivo",
  "perm.action.defender.scan": "Varrer",
  "perm.action.defender.exclusion": "Aprovar exclusões",
  "perm.action.vulns.export": "Exportar CSV",
  "perm.action.vulns.approveRisk": "Aprovar aceite de risco",
  "perm.action.diskEncryption.revealKey": "Revelar chave de recuperação",
  "perm.action.remote.approve": "Aprovar acesso sem assistência",
  "perm.action.licenses.revealKey": "Revelar chaves de licença",
  "perm.action.reports.export": "Exportar",
  "perm.action.reports.schedule": "Agendar envio",
  "perm.action.deployments.approve": "Aprovar implantações",
  "perm.action.scripts.run": "Executar scripts",
  "perm.action.playbooks.run": "Executar playbooks",
  "perm.action.privileges.grant": "Conceder elevação",
  "perm.action.credentials.reveal": "Revelar credenciais",
  "perm.action.users.profiles": "Editar perfis",
  "perm.action.users.signIn": "Configurar a entrada",
  "perm.action.users.apiAccounts": "Contas de API",
  "perm.action.audit.export": "Exportar auditoria",
  "perm.action.support.approve": "Aprovar suporte do fornecedor",
  "nav.uninstallCode": "Contra-senha",
  "uc.title": "Contra-senha de desinstalação",
  "uc.sub": "O agente só sai de uma máquina com ordem da console ou com esta contra-senha de uso único. Digite o desafio que a máquina mostrou.",
  "uc.machine": "Máquina",
  "uc.choose": "Escolha a máquina",
  "uc.challenge": "Desafio mostrado na máquina",
  "uc.reason": "Por quê (vai para a auditoria)",
  "uc.generate": "Gerar contra-senha",
  "uc.answer": "Dite para quem está na máquina",
  "uc.validUntil": "Vale até {at}, uso único",
  "uc.pending": "Servidores e Tier 0 pedem a aprovação de outra pessoa; a contra-senha aparece aqui e na ficha do agente depois de aprovada.",
  "uc.note": "Só perfis com essa ação liberada veem esta tela. Cada contra-senha vale uma vez, por poucos minutos, e todo pedido fica na auditoria.",
  "perm.action.agents.uninstallCode": "Contra-senha de desinstalação (celular)",
};

const es: Record<K, string> = {
  'users.title': 'Usuarios y perfiles',
  'users.sub': 'Quién usa la consola, con qué perfil y cómo inicia sesión. Los perfiles combinan permisos por área con un alcance de datos.',
  'users.tab.people': 'Personas',
  'users.tab.profiles': 'Perfiles',
  'users.tab.groups': 'Grupos del directorio',
  'users.tab.auth': 'Autenticación',
  'users.invite': 'Invitar personas',
  'users.inviteHint': 'O vincule un grupo del directorio a un perfil (pestaña Grupos del directorio).',
  'users.search': 'Buscar por nombre o correo',
  'users.searchPlaceholder': 'P. ej. sampaio',
  'users.statusFilter': 'Estado',
  'users.status.active': 'Activa',
  'users.status.invited': 'Invitada',
  'users.status.disabled': 'Desactivada',
  'users.status.pending': 'Esperando acceso',
  'users.grant': 'Conceder acceso',
  'users.reject': 'Rechazar',
  'users.grant.title': 'Conceder acceso a {name}',
  'users.grant.text': 'Esta persona inició sesión por el proveedor de identidad sin invitación. Elija los perfiles; el primero pasa a ser el activo.',
  'users.grant.ok': 'Conceder acceso',
  'users.grant.done': 'Acceso concedido a {email}.',
  'users.reject.title': '¿Rechazar {email}?',
  'users.reject.text': 'Sin bloquear, el registro se elimina y un nuevo inicio de sesión vuelve a pedir acceso. Al bloquear, queda desactivado y se rechazan nuevos inicios de sesión.',
  'users.reject.block': 'Bloquear nuevos inicios de sesión',
  'users.reject.ok': 'Rechazar',
  'users.reject.done': 'Solicitud de acceso de {email} rechazada.',
  'users.pendingNote': 'Quien espera acceso inició sesión por el proveedor de identidad sin invitación. Conceda un perfil o rechace.',
  'auth.self.title': 'Quien inicia sesión sin invitación',
  'auth.self.sub': 'Quien inicia sesión por el proveedor de identidad (OIDC, SAML o Active Directory) con un correo desconocido y sin grupo del directorio asignado. Vale para todos los métodos.',
  'auth.self.refuse': 'Rechazar el inicio de sesión (predeterminado)',
  'auth.self.refuseDesc': 'La persona lee que todavía no tiene acceso. No se registra nada.',
  'auth.self.register': 'Registrar esperando acceso',
  'auth.self.registerDesc': 'La persona se crea sin ningún perfil y no puede usar Hive. Los administradores de personas reciben un correo y conceden o rechazan el acceso en Personas.',
  'auth.self.hint': 'Un grupo del directorio asignado sigue valiendo: sus miembros entran directo con sus perfiles. El cambio se audita y se versiona.',
  'auth.self.saved': 'Configuración guardada.',
  'users.empty': 'Nadie coincide con esta búsqueda.',
  'users.col.person': 'Persona',
  'users.col.profiles': 'Perfiles',
  'users.col.status': 'Estado',
  'users.col.last': 'Último acceso',
  'users.notYet': 'todavía no',
  'users.editOf': 'Editar {name}',
  'users.resend': 'Reenviar invitación',
  'users.resent': 'Invitación reenviada a {email}.',
  'users.privileged': 'Privilegiado: siempre pide MFA.',
  'users.invite.done.one': '{count} persona invitada.',
  'users.invite.done.other': '{count} personas invitadas.',
  'users.invite.emailSent': 'Cada persona recibe un correo para definir la contraseña.',
  'users.invite.noEmail': 'No se envió ningún correo (inicio de sesión con la cuenta de la empresa): comparta la dirección de abajo.',
  'users.invite.already': 'Ya tenían acceso (omitidas):',
  'users.invite.address': 'Dirección de inicio de sesión de su empresa',
  'users.invite.addressHint': 'Si el correo no llega, copie esta dirección y envíela por otro medio.',
  'users.editTitle': 'Acceso de {name}',
  'users.profilesHint': 'El primer perfil pasa a ser el activo. Los cambios valen en la próxima acción de la persona, sin iniciar sesión de nuevo.',
  'users.statusHint': 'Una persona desactivada no inicia sesión; el historial y la auditoría se mantienen.',
  'users.cantDisableSelf': 'No puede desactivar su propio acceso.',
  'users.disable.title': '¿Desactivar {email}?',
  'users.disable.text': 'El inicio de sesión se detiene de inmediato, en Hive y en la cuenta local. Puede reactivarlo después.',
  'users.disable.ok': 'Desactivar acceso',
  'users.saved': 'Acceso de {email} guardado.',

  'profiles.new': 'Nuevo perfil',
  'profiles.hint': 'Los perfiles predeterminados pueden duplicarse y ajustarse; el original nunca cambia.',
  'profiles.empty': 'Todavía no hay perfiles.',
  'profiles.builtin': 'Predeterminado',
  'profiles.custom': 'Creado por la empresa',
  'profiles.privileged': 'Privilegiado · MFA siempre',
  'profiles.people.one': '{count} persona',
  'profiles.people.other': '{count} personas',
  'profiles.duplicate': 'Duplicar y ajustar',
  'profiles.permCount.one': '{count} permiso',
  'profiles.permCount.other': '{count} permisos',
  'profiles.mfa.privileged': 'MFA siempre (perfil privilegiado)',
  'profiles.mfa.required': 'MFA siempre obligatorio',
  'profiles.mfa.outside': 'MFA fuera de la red de la empresa',
  'profiles.mfa.idp': 'MFA según el proveedor de identidad',
  'profiles.mfaOpt.required': 'Siempre obligatorio',
  'profiles.mfaOpt.outside-network': 'Obligatorio fuera de la red de la empresa',
  'profiles.mfaOpt.idp': 'Según el proveedor de identidad',
  'profiles.delete.title': '¿Eliminar el perfil {name}?',
  'profiles.delete.text': 'Solo puede eliminarse cuando nadie lo tiene. Las versiones siguen en el registro de auditoría.',
  'profiles.delete.ok': 'Eliminar perfil',
  'profiles.deleted': 'Perfil {name} eliminado.',
  'profiles.back': 'Volver a los perfiles',
  'profiles.editTitle': 'Editar perfil: {name}',
  'profiles.duplicateTitle': 'Duplicar y ajustar perfil',
  'profiles.copyOf': '{name} (copia)',
  'profiles.editorSub': 'Permisos por área, alcance de datos y política de MFA. Guardar crea una versión que puede compararse y restaurarse.',
  'profiles.saveChanges': 'Guardar cambios',
  'profiles.scopeNote': "El alcance limita qué activos ve el perfil. Se aplica en cuanto se guarda el perfil.",
  'profiles.permNote': "Aparecen todos los permisos del producto, incluso de módulos aún no usados, para que el perfil esté listo cuando se activen.",
  'profiles.savedVersion': 'Perfil guardado (versión {version}). Vale en la próxima acción de cada persona.',
  'profiles.undone': 'Cambio deshecho: la versión anterior volvió a valer.',
  'profiles.savedTitle': 'Perfil {name} guardado.',
  'profiles.savedText': 'Está en el registro de auditoría y ya tiene la primera versión.',
  'profiles.savedTextEdit': 'El cambio está en el registro de auditoría y creó una versión nueva que puede compararse y restaurarse.',
  'profiles.editAgain': 'Abrir el perfil',

  'versions.title': 'Versiones',
  'versions.none': 'Todavía no hay versiones. La primera nace en el próximo guardado.',
  'versions.current': 'actual',
  'versions.legendOut': 'Valor que salió',
  'versions.legendIn': 'Valor que entró',
  'versions.compare': 'Comparación entre la versión {a} y la versión {b}',
  'versions.field': 'Campo',
  'versions.before': 'v{version} · antes',
  'versions.after': 'v{version} · actual',
  'versions.same': 'No hay diferencias entre estas versiones.',
  'versions.changed': 'cambiado',
  'versions.added': 'agregado',
  'versions.restore': 'Restaurar la versión {version}',
  'versions.restoreTitle': '¿Restaurar la versión {version}?',
  'versions.restoreText': 'Los valores de esa versión vuelven a valer. La restauración también crea una versión nueva ({next}), así que puede volver atrás.',
  'versions.restored': 'Versión restaurada como v{version}.',
  'versions.noRestore': 'Su perfil activo puede comparar versiones, pero no restaurarlas.',
  'versions.scopeAll': 'Toda la empresa',
  'versions.scope.sites': 'Sitios',
  'versions.scope.tags': 'Etiquetas',
  'versions.scope.groups': 'Grupos',
  'versions.path.name': 'Nombre del perfil',
  'versions.path.description': 'Para quién es',
  'versions.path.permissions': 'Permisos',
  'versions.path.privileged': 'Perfil privilegiado',
  'versions.path.mfa': 'Política de MFA',
  'versions.path.scope': 'Alcance de datos',

  'groups.note': 'Quien inicia sesión con la cuenta de la empresa y está en un grupo asignado obtiene el perfil sin invitación manual (JIT). Quien sale del grupo lo pierde en el próximo acceso.',
  'groups.col.group': 'Grupo del directorio',
  'groups.col.profile': 'Perfil otorgado',
  'groups.empty': 'Todavía no hay grupos asignados.',
  'groups.add': 'Agregar grupo',
  'groups.save': 'Guardar asignaciones',
  'groups.remove': 'Quitar el grupo {group}',
  'groups.saved.one': '{count} asignación guardada.',
  'groups.saved.other': '{count} asignaciones guardadas.',

  'auth.intro': 'Solo los métodos activos aparecen en la pantalla de inicio de sesión. Las conexiones con directorios (Entra ID, Okta…) se gestionan en el Centro de integraciones.',
  'auth.introLink': 'Abrir el Centro de integraciones',
  'auth.oidc.title': 'OIDC / OAuth 2.0',
  'auth.oidc.desc': 'Iniciar sesión con el proveedor de identidad de la empresa: Entra ID, Google, Okta, Keycloak.',
  'auth.saml.title': 'SAML 2.0',
  'auth.saml.desc': 'Para proveedores de identidad que solo hablan SAML (ADFS y otros).',
  'auth.ldap.title': 'LDAP / Active Directory',
  'auth.ldap.desc': 'Usuario y contraseña del dominio, validados en Active Directory por el colector vía LDAPS.',
  'auth.ldap.collector': 'Aplicado por el colector.',
  'auth.ldap.f1': "Aplicado por el colector: conecte antes el Active Directory (Integraciones › Directorio).",
  'auth.local.title': 'Cuenta local + MFA',
  'auth.local.desc': 'Para instalaciones sin proveedor de identidad, cuentas de emergencia y auditores externos.',
  'auth.local.summary': 'Contraseña fuerte; MFA obligatorio para perfiles privilegiados.',
  'auth.on': 'Activo',
  'auth.offState': 'Inactivo',
  'auth.notConfigured': 'Todavía no configurado.',
  'auth.configure': 'Configurar',
  'auth.toggle': 'Activar o desactivar {method}',
  'auth.turnedOn': '{method} activado. La pantalla de inicio de sesión ya lo muestra.',
  'auth.turnedOff': '{method} desactivado.',
  'auth.off.title': '¿Desactivar {method}?',
  'auth.off.text': 'Quien inicia sesión por este método necesitará otro. Al menos un método siempre queda activo.',
  'auth.off.ok': 'Desactivar',
  'auth.wz.redirect': 'Registre esta dirección de retorno en el proveedor de identidad (es lo único que debe copiar):',
  'auth.wz.done': '{method} guardado y activado.',
  'auth.wz.doneText': 'El secreto fue a la bóveda y nunca vuelve a mostrarse. La pantalla de inicio de sesión ya muestra esta opción.',
  'auth.wz.test': 'Probar el inicio de sesión',
  'auth.wz.testHint': 'Abra esta dirección en una ventana privada y elija “Iniciar sesión con la cuenta de la empresa”. Si algo falla, el error aparece allí con el motivo.',
  'auth.mfa.title': 'Política de MFA por perfil',
  'auth.mfa.sub': 'los perfiles privilegiados siempre exigen MFA, aunque el proveedor de identidad no lo pida',
  'auth.mfa.profile': 'Perfil',
  'auth.mfa.policy': 'MFA',
  'auth.mfa.hint': 'Cambie la política en el editor del perfil.',

  'support.title': 'Solicitudes de acceso de soporte del proveedor de servicios',
  'support.sub': 'solo valen con su aprobación, por tiempo limitado, y cada acción va al registro de auditoría',
  'support.empty': 'No hay solicitudes.',
  'support.emptyText': 'Cuando el equipo del proveedor pida ayudar, la solicitud aparece aquí para que la apruebe o la rechace.',
  'support.status.pending': 'Esperando aprobación',
  'support.status.approved': 'Aprobado',
  'support.status.denied': 'Rechazado',
  'support.status.revoked': 'Revocado',
  'support.status.expired': 'Vencido',
  'support.approveFor': 'Aprobar por {minutes} min',
  'support.requested': 'solicitado {when}',
  'support.until': 'hasta {when}',
  'support.decidedBy': 'decidido por {who}',
  'support.approve.title': '¿Aprobar el acceso de {who}?',
  'support.approve.text': 'Acceso de solo lectura por {minutes} minutos. Cada acción queda en su registro de auditoría; puede revocarlo en cualquier momento.',
  'support.approve.ok': 'Aprobar',
  'support.approve.done': 'Acceso aprobado. Termina solo al final del plazo.',
  'support.deny.title': '¿Rechazar la solicitud de {who}?',
  'support.deny.text': 'El equipo del proveedor no verá sus datos.',
  'support.deny.ok': 'Rechazar',
  'support.deny.done': 'Solicitud rechazada.',
  'support.revoke.title': '¿Revocar ahora el acceso de {who}?',
  'support.revoke.text': 'El acceso termina de inmediato, incluso antes de los {minutes} minutos.',
  'support.revoke.ok': 'Revocar ahora',
  'support.revoke.done': 'Acceso revocado.',

  'profile.platform-admin': 'Administrador de la plataforma',
  'profile.noc-analyst': 'Analista de infraestructura / NOC',
  'profile.security-analyst': 'Analista de seguridad',
  'profile.support-technician': 'Técnico de soporte (N1/N2)',
  'profile.license-manager': 'Gestor de licencias (SAM)',
  'profile.asset-analyst': 'Analista de activos (HAM)',
  'profile.manager': 'Gerente / ejecutivo',
  'profile.auditor': 'Auditor',
  'profile.end-user': 'Usuario final',
  'profile.platform-admin.desc': 'Administra todo en la empresa: personas, perfiles, inicio de sesión, integraciones y configuración.',
  'profile.noc-analyst.desc': 'Inventario, alertas, agentes e informes.',
  'profile.security-analyst.desc': 'Vulnerabilidades, alertas, informes y registro de auditoría.',
  'profile.support-technician.desc': 'Ve activos y alertas e inicia acceso remoto con consentimiento.',
  'profile.license-manager.desc': 'Licencias, contratos y la Tienda de software.',
  'profile.asset-analyst.desc': 'Inventario y ciclo de vida del hardware.',
  'profile.manager.desc': 'Lee resúmenes e informes.',
  'profile.auditor.desc': 'Lee el registro de auditoría, las versiones de configuración y los informes.',
  'profile.end-user.desc': 'Usa la ayuda y la Tienda de software.',

  'area.agents': 'Agentes',
  'area.alerts': 'Alertas',
  'area.api': 'API',
  'area.assets': 'Activos e inventario',
  'area.audit': 'Auditoría',
  'area.auth': 'Inicio de sesión',
  'area.config': 'Versiones de configuración',
  'area.help': 'Ayuda',
  'area.home': 'Inicio',
  'area.integrations': 'Integraciones',
  'area.licenses': 'Licencias',
  'area.profiles': 'Perfiles',
  'area.remote': 'Acceso remoto',
  'area.reports': 'Informes y paneles',
  'area.settings': 'Configuración de la empresa',
  'area.store': 'Tienda de software',
  'area.support': 'Acceso de soporte',
  'area.users': 'Personas',
  'area.vulnerabilities': 'Vulnerabilidades',

  'perm.home:read': 'Ver el Inicio',
  'perm.users:read': 'Ver personas y perfiles',
  'perm.users:admin': 'Invitar y administrar personas',
  'perm.profiles:admin': 'Crear y editar perfiles',
  'perm.auth:admin': 'Configurar métodos de inicio de sesión',
  'perm.settings:admin': 'Cambiar la configuración de la empresa',
  'perm.audit:read': 'Leer el registro de auditoría',
  'perm.config:read': 'Ver versiones de configuración',
  'perm.config:write': 'Restaurar versiones de configuración',
  'perm.integrations:read': 'Ver integraciones',
  'perm.integrations:admin': 'Conectar y administrar integraciones',
  'perm.api:admin': 'Administrar cuentas de integración (API)',
  'perm.support:approve': 'Aprobar acceso de soporte',
  'perm.help:read': 'Usar la ayuda',
  'perm.assets:read': 'Ver activos',
  'perm.trust:read': 'Leer la señal de confianza del equipo (acceso condicional)',
  'perm.assets:write': 'Editar activos',
  'perm.alerts:read': 'Ver alertas',
  'perm.alerts:admin': 'Administrar reglas de alerta',
  'perm.agents:admin': 'Administrar agentes',
  'perm.reports:read': 'Ver informes y paneles',
  'perm.reports:write': 'Crear informes y paneles',
  'perm.vulnerabilities:read': 'Ver vulnerabilidades',
  'perm.licenses:admin': 'Administrar licencias y contratos',
  'perm.remote:access': 'Iniciar acceso remoto',
  'perm.store:use': 'Usar la Tienda de software',
  'perm.store:admin': 'Administrar la Tienda de software',

  'scope.assets': 'Activos y detalles',
  'scope.software': 'Software y uso',
  'scope.relationships': 'Relaciones y mapas',
  'scope.network': 'Red (puertos, VLANs, subredes)',
  'scope.cloud': 'Nube, virtualización y Kubernetes',
  'scope.contracts': 'Contratos, licencias y SKUs',
  'scope.vulnerabilities': 'Vulnerabilidades e insights',
  'scope.alerts': 'Alertas y eventos',
  'scope.tickets': 'Tickets y cambios',
  'scope.reports': 'Informes',
  'scope.audit': 'Registro de auditoría',
  'scope.identity': 'Personas e identidad',
  'scope.trust': 'Señal de confianza de los equipos (acceso condicional)',
  'perm.vulnerabilities:approve': 'Aprobar aceptación de riesgo',
  'perm.licenses:keys-view': 'Ver claves de licencia',
  "pmx.search": "Buscar pantalla o acción",
  "pmx.onlyMarked": "Solo marcadas",
  "pmx.count": "{n} de {total} marcadas",
  "pmx.screen": "Pantalla",
  "pmx.view": "Ver",
  "pmx.edit": "Editar",
  "pmx.actions": "Acciones específicas",
  "pmx.blockView": "Ver todas las pantallas de {block}",
  "pmx.blockEdit": "Editar todas las pantallas de {block}",
  "pmx.viewOf": "Ver {screen}",
  "pmx.editOf": "Editar {screen}",
  "pmx.sensitive": "Acción sensible: requiere perfil privilegiado (con MFA)",
  "pmx.sensitiveNote": "Las acciones sensibles deben quedar solo en perfiles privilegiados, que siempre exigen MFA.",
  "perm.action.assets.export": "Exportar la lista",
  "perm.action.assets.retire": "Retirar activos",
  "perm.action.assets.changeKind": "Cambiar el tipo",
  "perm.action.agents.install": "Crear instaladores",
  "perm.action.agents.classApprove": "Aprobar cambio de clase",
  "perm.action.discovery.run": "Ejecutar escaneos",
  "perm.action.maps.shareMap": "Compartir mapas",
  "perm.action.alerts.acknowledge": "Reconocer",
  "perm.action.alerts.close": "Resolver y cerrar",
  "perm.action.itsm.openTicket": "Abrir tickets",
  "perm.action.response.isolate": "Aislar equipo",
  "perm.action.response.killProcess": "Terminar proceso",
  "perm.action.response.emergencyBrake": "Freno de emergencia",
  "perm.action.hunting.falsePositive": "Marcar falso positivo",
  "perm.action.defender.scan": "Analizar",
  "perm.action.defender.exclusion": "Aprobar exclusiones",
  "perm.action.vulns.export": "Exportar CSV",
  "perm.action.vulns.approveRisk": "Aprobar aceptación de riesgo",
  "perm.action.diskEncryption.revealKey": "Revelar clave de recuperación",
  "perm.action.remote.approve": "Aprobar acceso desatendido",
  "perm.action.licenses.revealKey": "Revelar claves de licencia",
  "perm.action.reports.export": "Exportar",
  "perm.action.reports.schedule": "Programar envío",
  "perm.action.deployments.approve": "Aprobar implementaciones",
  "perm.action.scripts.run": "Ejecutar scripts",
  "perm.action.playbooks.run": "Ejecutar playbooks",
  "perm.action.privileges.grant": "Conceder elevación",
  "perm.action.credentials.reveal": "Revelar credenciales",
  "perm.action.users.profiles": "Editar perfiles",
  "perm.action.users.signIn": "Configurar el acceso",
  "perm.action.users.apiAccounts": "Cuentas de API",
  "perm.action.audit.export": "Exportar auditoría",
  "perm.action.support.approve": "Aprobar soporte del proveedor",
  "nav.uninstallCode": "Contraseña",
  "uc.title": "Contraseña de desinstalación",
  "uc.sub": "El agente solo sale de un equipo con orden de la consola o con esta contraseña de un solo uso. Escriba el desafío que mostró el equipo.",
  "uc.machine": "Equipo",
  "uc.choose": "Elija el equipo",
  "uc.challenge": "Desafío mostrado en el equipo",
  "uc.reason": "Por qué (va a la auditoría)",
  "uc.generate": "Generar contraseña",
  "uc.answer": "Dicte a quien está en el equipo",
  "uc.validUntil": "Válida hasta {at}, un solo uso",
  "uc.pending": "Servidores y Tier 0 requieren la aprobación de otra persona; la contraseña aparece aquí y en la ficha del agente al aprobarse.",
  "uc.note": "Solo los perfiles con esta acción ven esta pantalla. Cada contraseña vale una vez, por pocos minutos, y todo pedido queda en la auditoría.",
  "perm.action.agents.uninstallCode": "Contraseña de desinstalación (móvil)",
};

export const usersMessages = { en, 'pt-BR': ptBR, es } as const;
